const pageGuide = document.querySelector('.c-pillar-page__guide')
const mobileGuide = document.querySelector('.c-pillar-page__mobile-guide')
const mobileGuideSelect = document.querySelector('.c-pillar-page__mobile-guide select')
const guideLinks = Array.from(document.querySelectorAll('.c-pillar-page__guide-link'))

const MOBILE_BREAKPOINT = 900

export default () => {
  // Jump to anchor on mobile guide select change
  mobileGuideSelect?.addEventListener('change', (ev) => {
    const section = document.getElementById(mobileGuideSelect.value)
    section?.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
      inline: 'start',
    })
  })

  // Scroll to anchor on desktop/sticky guide link click
  guideLinks?.forEach((link) => {
    link.addEventListener('click', (ev) => {
      const section = document.getElementById(link.dataset.id || '')
      if (section) {
        ev.preventDefault()
        section.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
          inline: 'start',
        })
      }
    })
  })

  // Show/hide the mobile menu when you scroll past the page guide
  if (pageGuide && mobileGuide) {
    let scrollDebounce = null
    const handleScroll = () => {
      window.clearTimeout(scrollDebounce)
      scrollDebounce = null

      const pos = pageGuide.getBoundingClientRect()
      if (window.innerWidth < MOBILE_BREAKPOINT && pos.y + pos.height < 0) {
        mobileGuide.style.top = 0
      } else {
        mobileGuide.style.top = '-100px'
      }
    }

    // Throttle the scroll handler
    window.addEventListener('scroll', () => {
      if (!scrollDebounce) {
        scrollDebounce = window.setTimeout(handleScroll, 200)
      }
    })
  }

  // Highlight the different skip links as we scroll down the page
  guideLinks?.forEach((item) => {
    const sectionID = item.dataset.id || ''
    const section = document.getElementById(sectionID)

    if (!section) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveLink(item)
        })
      },
      {
        // Just using a small area at top of window to check intersection
        // Otherwise if you scroll down into a new area but then scroll back up before entirely leaving the previous
        // it'll leave the selection on the later even after the later isn't on screen any longer.
        rootMargin: '-10% 0% -90% 0%',
      },
    )

    observer.observe(section)
  })
}

// Highlights the given guide jump link (for either/both desktop and mobile)
const setActiveLink = (link) => {
  Array.from(document.querySelectorAll('.c-pillar-page__guide-link--active')).forEach((item) => {
    item.classList.remove('c-pillar-page__guide-link--active')
  })
  link.classList.add('c-pillar-page__guide-link--active')
  if (mobileGuideSelect) mobileGuideSelect.value = link.dataset.id
}
